import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaPlus, FaTimes } from 'react-icons/fa';

import api from '~/services/api';
import history from '~/services/history';

import {
  Container,
  Content,
  Header,
  GeneralButton,
  DeleteButton,
  QuestionForm,
  QuestionInput,
  AwnserInput,
  CommentInput,
  ConfirmButton,
  CategoriesSection,
  CategoryTag,
  Footer,
  ConfirmModal,
} from './styles';

export default function AddQuestion({ match }) {
  const [questionID] = useState(
    match.params.question === 'new' ? 0 : Number(match.params.question)
  );

  const [question, setQuestion] = useState('');
  const [option0, setOption0] = useState('');
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [option3, setOption3] = useState('');
  const [comment, setComment] = useState('');
  const [newCategory, setNewCategory] = useState('');
  const [categories, setCategories] = useState([]);

  const [modalStatus, setModalStatus] = useState(0);

  useEffect(() => {
    async function readQuestion() {
      const response = await api.get(`questions/${questionID}`);

      setQuestion(response.data.question);

      setOption0(response.data.option_0);
      setOption1(response.data.option_1);
      setOption2(response.data.option_2);
      setOption3(response.data.option_3);

      setComment(response.data.comment);

      setCategories(response.data.categories);
    }

    if (questionID > 0) {
      readQuestion();
    }
  }, [questionID]);

  function handleClearState() {
    setQuestion('');
    setOption0('');
    setOption1('');
    setOption2('');
    setOption3('');
    setComment('');
    setNewCategory('');
    setCategories([]);
  }

  function handleChangeInput(input, value) {
    switch (input) {
      case 'question':
        setQuestion(value);
        break;

      case 'opt0':
        setOption0(value);
        break;

      case 'opt1':
        setOption1(value);
        break;

      case 'opt2':
        setOption2(value);
        break;

      case 'opt3':
        setOption3(value);
        break;

      case 'comment':
        setComment(value);
        break;

      case 'category':
        setNewCategory(value);
        break;

      default:
        break;
    }
  }

  function handleAddNewCategory() {
    if (newCategory !== '') {
      const categoryAlredyExists = categories.filter(
        category => category === newCategory
      );

      if (categoryAlredyExists.length === 0) {
        const draft = categories;
        draft.push(newCategory);
        setNewCategory('');
        setCategories([...draft]);
      }
    }
  }

  function handleDeleteCategory(category) {
    const newCategories = categories.filter(cat => cat !== category);

    setCategories(newCategories);
  }

  async function handleReallyDeleteQuestion() {
    const response = await api.delete(`questions/${questionID}`);

    setModalStatus(response.status === 200 ? 2 : -1);
  }

  async function handleSubmit(data) {
    const payload = {
      categories: [...categories],
      answer: 0,
      ...data,
    };

    if (questionID > 0) {
      const response = await api.put(`questions/${questionID}`, {
        ...payload,
      });

      setModalStatus(response.status === 200 ? 3 : -1);
    } else {
      const response = await api.post('questions', {
        ...payload,
      });

      setModalStatus(response.status === 200 ? 4 : -1);
    }
  }

  return (
    <Container>
      <Content blur={modalStatus !== 0}>
        <Header>
          <h1>{questionID > 0 ? `Questão #${questionID}` : 'Nova Questão'}</h1>

          <div>
            {questionID > 0 ? (
              <DeleteButton type="button" onClick={() => setModalStatus(1)}>
                Deletar
              </DeleteButton>
            ) : null}
            <GeneralButton type="button" onClick={() => handleClearState()}>
              Limpar
            </GeneralButton>
            <GeneralButton type="button" onClick={() => history.push('/panel')}>
              Cancelar
            </GeneralButton>
          </div>
        </Header>

        <QuestionForm onSubmit={handleSubmit}>
          <QuestionInput
            name="question"
            multiline
            autoFocus
            required
            maxLength="255"
            placeholder="Digite aqui a pergunta"
            value={question}
            onChange={e => handleChangeInput('question', e.target.value)}
          />

          <AwnserInput
            name="option_0"
            required
            maxLength="255"
            type="text"
            placeholder="Respota CORRETA"
            value={option0}
            onChange={e => handleChangeInput('opt0', e.target.value)}
          />
          <AwnserInput
            name="option_1"
            required
            maxLength="255"
            type="text"
            placeholder="Respota INCORRETA"
            value={option1}
            onChange={e => handleChangeInput('opt1', e.target.value)}
          />
          <AwnserInput
            name="option_2"
            required
            maxLength="255"
            type="text"
            placeholder="Respota INCORRETA"
            value={option2}
            onChange={e => handleChangeInput('opt2', e.target.value)}
          />
          <AwnserInput
            name="option_3"
            required
            maxLength="255"
            type="text"
            placeholder="Respota INCORRETA"
            value={option3}
            onChange={e => handleChangeInput('opt3', e.target.value)}
          />

          <CommentInput
            name="comment"
            multiline
            maxLength="255"
            placeholder="Comentários"
            value={comment}
            onChange={e => handleChangeInput('comment', e.target.value)}
          />

          <CategoriesSection>
            <div>
              <input
                placeholder="Adicionar categoria"
                value={newCategory}
                onChange={e => handleChangeInput('category', e.target.value)}
              />
              <GeneralButton
                type="button"
                onClick={() => handleAddNewCategory()}
              >
                <FaPlus size={22} color="#fff" />
              </GeneralButton>
            </div>

            <div>
              {categories.map(category => (
                <CategoryTag key={category}>
                  {category}
                  <GeneralButton
                    type="button"
                    onClick={() => handleDeleteCategory(category)}
                  >
                    <FaTimes size={12} color="#fff" />
                  </GeneralButton>
                </CategoryTag>
              ))}
            </div>
          </CategoriesSection>

          <Footer>
            <ConfirmButton type="submit">Confirmar</ConfirmButton>
            <GeneralButton type="button" onClick={() => history.push('/panel')}>
              Cancelar
            </GeneralButton>
          </Footer>
        </QuestionForm>
      </Content>

      <ConfirmModal open={modalStatus !== 0}>
        <div>
          <Modal
            questionID={questionID}
            status={modalStatus}
            setStatus={setModalStatus}
            handleReallyDeleteQuestion={handleReallyDeleteQuestion}
          />
        </div>
      </ConfirmModal>
    </Container>
  );
}

function Modal({ questionID, status, setStatus, handleReallyDeleteQuestion }) {
  switch (status) {
    case 1: // Comfirm delete status
      return (
        <>
          <h2>Questão # {questionID}</h2>
          <h3>Deseja mesmo deletar essa questão?</h3>

          <span>
            <DeleteButton
              type="button"
              onClick={() => handleReallyDeleteQuestion()}
            >
              Deletar
            </DeleteButton>
            <GeneralButton type="button" onClick={() => setStatus(0)}>
              Cancelar
            </GeneralButton>
          </span>
        </>
      );

    case 2:
      return (
        <>
          <h2>Questão # {questionID}</h2>
          <h3>Deletada com sucesso!</h3>

          <span>
            <GeneralButton type="button" onClick={() => history.push('/panel')}>
              Ok
            </GeneralButton>
          </span>
        </>
      );

    case 3:
      return (
        <>
          <h2>Questão # {questionID}</h2>
          <h3>Atualizada com sucesso!</h3>
          <span>
            <GeneralButton type="button" onClick={() => history.push('/panel')}>
              Ok
            </GeneralButton>
          </span>
        </>
      );

    case 4:
      return (
        <>
          <h2>Nova questão</h2>
          <h3>Cadastrada com sucesso!</h3>

          <span>
            <GeneralButton type="button" onClick={() => history.push('/panel')}>
              Ok
            </GeneralButton>
          </span>
        </>
      );

    default:
      return (
        <>
          <h2>Questão # {questionID}</h2>
          <h3>Ops! Algo deu errado...</h3>

          <span>
            <GeneralButton type="button" onClick={() => setStatus(0)}>
              Ok
            </GeneralButton>
          </span>
        </>
      );
  }
}

AddQuestion.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      question: PropTypes.string,
    }),
  }).isRequired,
};

Modal.propTypes = {
  questionID: PropTypes.number.isRequired,
  status: PropTypes.number.isRequired,
  setStatus: PropTypes.func.isRequired,
  handleReallyDeleteQuestion: PropTypes.func.isRequired,
};
